"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
let PolygonGeodata = class PolygonGeodata extends vue_property_decorator_1.Vue {
    get sizeCurated() {
        return this.size || 30;
    }
    get stroke() {
        return this.color || '#85DF4F';
    }
    get fill() {
        return this.color ? `${this.color}50` : '#85DF4F50';
    }
    get strokeWidth() {
        const allMatches = [...this.geodata.matchAll(/-?\d+(\.\d+)?/g)];
        const allCoords = allMatches.map(m => Number(m[0])).filter(n => !isNaN(n));
        if (allCoords.length < 4)
            return 0.0005;
        const xCoords = allCoords.filter((_, i) => i % 2 === 0);
        const yCoords = allCoords.filter((_, i) => i % 2 === 1);
        const width = Math.max(...xCoords) - Math.min(...xCoords);
        const height = Math.max(...yCoords) - Math.min(...yCoords);
        const diagonal = Math.sqrt(width ** 2 + height ** 2);
        return diagonal * 0.1; // ajusta este factor si es muy grueso o fino
    }
    get svgContent() {
        if (!this.geodata || typeof this.geodata !== 'string')
            return '';
        // Extraer paths individuales (empiezan con M)
        const pathStrings = this.geodata
            .trim()
            .split('M')
            .filter(p => p.trim().length > 0)
            .map(p => 'M' + p.trim());
        // Extraer todos los números como coordenadas
        const allMatches = [...this.geodata.matchAll(/-?\d+(\.\d+)?/g)];
        const allCoords = allMatches.map(m => Number(m[0])).filter(n => !isNaN(n));
        if (allCoords.length < 4) {
            // No hay suficientes coordenadas para generar un viewBox válido
            return `<svg xmlns="http://www.w3.org/2000/svg" width="${this.sizeCurated}" height="${this.sizeCurated}"></svg>`;
        }
        const xCoords = allCoords.filter((_, i) => i % 2 === 0);
        const yCoords = allCoords.filter((_, i) => i % 2 === 1);
        const minX = Math.min(...xCoords);
        const maxX = Math.max(...xCoords);
        const minY = Math.min(...yCoords);
        const maxY = Math.max(...yCoords);
        const padding = 0.001;
        const viewBox = `${minX - padding} ${minY - padding} ${maxX - minX + padding * 2} ${maxY - minY + padding * 2}`;
        const paths = pathStrings
            .map(d => `<path d="${d}" stroke="${this.stroke}" fill="${this.fill}" stroke-width="1" vector-effect="non-scaling-stroke"/>`)
            .join('\n');
        return `
      <svg xmlns="http://www.w3.org/2000/svg"
           width="${this.sizeCurated}"
           height="${this.sizeCurated}"
           viewBox="${viewBox}"
           preserveAspectRatio="xMidYMid meet">
        ${paths}
      </svg>
    `;
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: '' })
], PolygonGeodata.prototype, "geodata", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], PolygonGeodata.prototype, "color", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ default: null })
], PolygonGeodata.prototype, "size", void 0);
PolygonGeodata = __decorate([
    (0, vue_property_decorator_1.Options)({})
], PolygonGeodata);
exports.default = PolygonGeodata;
